import React, { useState, useEffect } from "react";
import axios from 'axios'
import { regexLink} from '../../sharedFunction';
import useInput from '../../Hooks/useInput'
import Presenter from './CommentSearchPresenter'
export default () => {
  const videoLink = useInput("");
  const search = useInput("");
  const [commentThread, setCommentThread] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageToken, setPageToken] = useState()
  const [existToken, setExistToken] = useState(null)
  const [scroll, setScroll] = useState(false)
  const [existError, setExistError] = useState(false)
  const [check, setCheck] = useState(false)
  const nextPageUrl = `https://www.googleapis.com/youtube/v3/commentThreads?part=snippet%2C%20replies&maxResults=100&pageToken=${pageToken}&videoId=${videoLink.value && regexLink(videoLink.value)}&key=${process.env.REACT_APP_GOOGLEAPIKEY}`;
  const GuidanceClick = () => {
    window.open(
      "https://www.notion.so/v1-1-1-fe6a0d44ee26436a9b674998cb1a7a2c"
    );
  }
  const inifiniteScroll = async () => {
    setScroll(true)
    let scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight)
    let scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    let clientHeight = document.documentElement.clientHeight
    if (existToken === true) {
      if (Math.floor(clientHeight + scrollTop) + 22 >= Math.floor(scrollHeight)) {
        // nextPageToken logic start
        setLoading(true);
        await axios.get(`${nextPageUrl}`).then((response) => {
          setCommentThread([...commentThread, ...response.data.items]);
          setPageToken(response.data.nextPageToken);
          if (response.data.nextPageToken) {
            setExistToken(true);
          } else {
            setExistToken(false);
          }
        });
        setLoading(false);
      }
    }
  }
  useEffect(() => {
    setScroll(false);
  }, [search.value])

  useEffect(() => {
    window.addEventListener("scroll", inifiniteScroll, true)
    return () => {
      window.removeEventListener("scroll", inifiniteScroll, true)
    }
  })
  const array = []
  commentThread.map((comment) => {
    if (
      comment.snippet.topLevelComment.snippet.textOriginal.includes(search.value)
    ) {
      array.push(comment)
    }
    return null
  })

  const moreData = async (e) => {
    e.preventDefault();
    setLoading(true);
    await axios
      .get(`${nextPageUrl}`)
      .then((response) => {
        setCommentThread([...commentThread, ...response.data.items]);
        setPageToken(response.data.nextPageToken);
        if (response.data.nextPageToken) {
          setExistToken(true);
        } else {
          setExistToken(false);
        }
      })
      .catch((error) => {
        /**
         * if error
         * [] commentThread reset
         * [] existError true
         */
        setCommentThread([]);
        setExistError(true);
      })
      .then(() => {
        setLoading(false);
      });
  }
  
  const onSubmit = async (e) => {
    /**
     * setExistError reset => 오류 걸렸을 경우 true를 통해 
     * setCheck true => onSubmit 을 보냈다는 확인을 통해 일단 데이터를 검색했다는걸 확인 => 더 검색이 필요하냐는걸 확인. ()
     */
    e.preventDefault();
    setCheck(true)
    setLoading(true)
    const url = `https://www.googleapis.com/youtube/v3/commentThreads?part=snippet%2C%20replies&maxResults=100&videoId=
${regexLink(videoLink.value)}&key=${process.env.REACT_APP_GOOGLEAPIKEY}`;
    await axios.get(`${url}`).then((res) => {
      setCommentThread(res.data.items)
      setPageToken(res.data.nextPageToken)
      setExistError(false);
      if (res.data.nextPageToken) {
        setExistToken(true)
      } else {
        setExistToken(false);
      }

    }).catch((error) => {
      /**
       * if error 
       * [] commentThread reset
       * [] existError true
       */
      setCommentThread([])
      setExistError(true)
      setCheck(false);
    }).then(() => {
      setLoading(false)
    })
  }
  


  return (
    <Presenter 
      onSubmit={onSubmit}
      videoLink={videoLink}
      search={search}
      commentThread={commentThread}
      loading={loading}
      pageToken={pageToken}
      existToken={existToken}
      scroll={scroll}
      existError={existError}
      check={check}
      GuidanceClick={GuidanceClick}
      array={array}
      moreData={moreData}
    />
  );
}

